import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const DollarCircleHidden = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019M15.3419 9.66984C15.3419 8.37984 14.3519 7.33984 13.1219 7.33984H10.6119C9.54187 7.33984 8.67188 8.24984 8.67188 9.36984C8.67188 10.5898 9.20187 11.0198 9.99187 11.2998L14.0219 12.6998C14.8119 12.9798 15.3419 13.4098 15.3419 14.6298C15.3419 14.7562 15.3308 14.88 15.3096 15M12 6V18M17 20.6622C15.5291 21.513 13.8214 22 12 22C6.47715 22 2 17.5228 2 12C2 10.0399 2.56392 8.21156 3.53838 6.66831M19.1896 18.9505C20.9295 17.1512 22 14.7006 22 12C22 6.47715 17.5228 2 12 2C9.27455 2 6.80375 3.09032 5 4.85857",
                stroke: "currentColor",
                strokeWidth: 1.5 * (24 / size),
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2 2L22 22",
                stroke: "currentColor",
                strokeWidth: 1.5 * (24 / size),
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
